module.exports = __webpack_public_path__ + "assets/img/healthy-icon.fc288a3a.png";